import React, { useEffect, useState } from 'react';
import { useTheme } from "../contexts/ThemeContext";
import { Navigate, useNavigate } from 'react-router-dom';

export default function Login() {

    const { isDarkMode, toggleTheme } = useTheme();
    const navigate = useNavigate();

    const [inputEmail, setInputEmail] = useState('');
    const [inputPassword, setInputPassword] = useState('');
    const [inputValue, setInputValue] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [authError, setAuthError] = useState<string | null>(null);


    const handleEmailChange = (event: any) => {
        setInputEmail(event.target.value);
        updateInputValue(event.target.value, inputPassword);
    };

    const handlePasswordChange = (event: any) => {
        setInputPassword(event.target.value);
        updateInputValue(inputEmail, event.target.value);
    };

    const updateInputValue = (inputEmail: any, inputPassword: any) => {
        setInputValue(inputEmail && inputPassword);
    };

    const validateEmail = (inputEmail: any) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(inputEmail);
    };

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (!inputEmail || !inputPassword) {
            setEmailError('Por favor, preencha todos os campos.');
            return;
        }
        if (!validateEmail(inputEmail)) {
            setEmailError('Por favor, insira um endereço de e-mail válido.');
            return;
        }

        // Simular erro de autenticação
        setAuthError("Login ou senha incorretos!");
    };

    return (
        <main className="flex w-[100%] h-screen flex-col items-center justify-center bg-gradient-to-br from-[#420C8D] to-[#615cb7] dark:bg-maincodeSecondBlueDark dark:text-white">
            <div className="lg:mt-20 bg-white dark:text-white lg:h-3/4 w-[90%] lg:w-2/6 flex flex-col justify-center p-10 lg:pl-14 lg:pr-14" style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
                <div>
                    <div className="mb-5">
                        {isDarkMode ? <button className=""><img src="/Logo_Horiz_Cor_Maincode.svg" alt="Logo" className="h-10" /></button> : <button className="" ><img src="/Logo_Horiz_Cor_Maincode.svg" alt="Logo" className="h-32" /></button>}
                    </div>
                </div>
                <div className="text-2xl mb-5">
                    <h1>Faça seu Login</h1>
                </div>
                <div>
                    <div>
                        <div className="border border-solid border-maincodeDarkGrey w-full lg:h-14 flex flex-col justify-center p-3 mb-5" style={{ borderRadius: '8px' }}>
                            <input type="email" value={inputEmail} onChange={handleEmailChange} placeholder="Digite seu e-mail" className="text-sm outline-none dark:bg-maincodeDarkBlueDark" />
                        </div>
                    </div>
                    <div>
                        <div className="border border-solid border-maincodeDarkGrey w-full lg:h-14 flex flex-col justify-center p-3 mb-5" style={{ borderRadius: '8px' }}>
                            <input type="password" value={inputPassword} onChange={handlePasswordChange} placeholder="Digite sua senha" className="text-sm outline-none dark:bg-maincodeDarkBlueDark" />
                        </div>
                    </div>
                    {authError && (
                        <p className="text-maincodeRed text-sm text-center mb-4">{authError}</p>
                    )}
                    <div >
                        <button onClick={handleSubmit} className={`px-4 py-2 rounded-lg ${inputValue ? 'bg-maincodeDarkBlue text-white mb-5' : 'bg-maincodeLightGrey text-white cursor-not-allowed mb-5'}`}>Continuar</button>
                    </div>
                </div>
                <div>
                    <p className="text-sm">Esqueceu sua senha? <a className="text-maincodeDarkBlue font-semibold" href='https://wa.me/5512997032407?text=Olá, perdi minha senha!' target='_blank'>Clique aqui</a></p>
                </div>
            </div>
            <div className='flex mt-5 text-white'>
                <button onClick={() => navigate('/')}>voltar ao site</button>
            </div>
        </main>
    );
}
